import React from 'react';
import PropTypes from 'prop-types';

import {
  FieldValue
} from '../../../packages/detail-panel';

import {
  ResourceCard,
  ResourceRef,
} from '../../resource';

import { 
  fmtIso8601AsLocalDateTime,
} from '../../utils/formatters';

export default function SubscriptionCard(props) {

  const { resource } = props;

  if(!resource) return(null); 

  const fields=[
    { section: "Details", fields: [
      { name: "ResourceId", label: "ID", component: FieldValue, options: { maxLength: 40 } }, 
      { name: "ClientAccountId", label: "Client", component: ResourceRef, options: { type: 'Client' } },
      { name: "StackCreated", label: "Created", formatter: fmtIso8601AsLocalDateTime },
      { name: "StackUpdated", label: "Updated", formatter: fmtIso8601AsLocalDateTime },
    ]},
    { section: "Subject", fields: [
      { name: "SubscribedResource.ResourceId", label: "Resource" },
      { name: "SubscribedResource.Prefix", label: "Prefix" },
      { name: "SubscribedResource.Suffix", label: "Suffix" },
    ]},
    { section: "Notifications", fields: [
      { name: "DeliveryConfiguration.Status", label: "Status" },
      { name: "DeliveryConfiguration.QueueUrl", label: "Target" },
    ]},
  ];

  return (
    <ResourceCard 
      resource={resource} 
      fields={fields} 
      stack 
      dashboard 
    />
  );
}

SubscriptionCard.propTypes = {
  resource: PropTypes.object.isRequired,
};

SubscriptionCard.defaultProps = {
};
